export default __webpack_public_path__ + "static/media/gallery-wip-emitter-body_07.72f4fe87.jpg";